import AddToCart from "./index";

export default class ViewCartAddToCart extends AddToCart {
  async addToCart() {
    this.cart.add = async () => {
      const addToCartInput = this.form.querySelector("[data-action=addToCart]");
      window.wss.shoppingCart.cartService.addRecommendedProductToCartHandler.apply(
        addToCartInput,
        [new Event("click")],
      );
    };

    super.addToCart();
  }
}
